export enum ECarnivalPeriod {
  MICARETA = 'MICARETA',
  OFFICIAL = 'OFFICIAL',
}



export default ECarnivalPeriod;
